import { getRoot } from 'core/router';
import { getRouterData } from 'navigation/component/Component';
import store from 'store';
import tag from 'core/tag';
import PageManager from './PageManager';
const decode = (str) => {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str)
        .split('')
        .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
};
function executeTag(tag) {
    if (tag)
        eval(tag); // eslint-disable-line no-eval
}
export const extractInfoFromXhr = (xhr) => {
    const auth = xhr.getResponseHeader('X-Fursac-Auth');
    const cart = xhr.getResponseHeader('X-Fursac-Cart');
    let error = xhr.getResponseHeader('X-Fursac-Error');
    let message = xhr.getResponseHeader('X-Fursac-Message');
    let events = xhr.getResponseHeader('X-Fursac-Events');
    const panel = xhr.getResponseHeader('X-Fursac-Panel'); // || 'cart|http://jonas.local:8080/fr/commande/panier.html'
    if (error)
        error = decode(error);
    if (message)
        message = decode(message);
    if (events)
        events = atob(events);
    if (!xhr.infoChecked) {
        if (auth)
            store.logged.set(!!parseInt(auth));
        if (cart)
            store.cart.set(parseInt(cart));
        if (panel) {
            const routerData = getRouterData(panel);
            if (routerData.tagName)
                tag.openPopin(routerData.tagName, 'panel');
            if (routerData.path) {
                setTimeout(() => {
                    store.panel.set(routerData.path.replace(getRoot(), ''));
                }, 300);
            }
        }
    }
    const page = xhr.response;
    const obj = extractInfo(page, { error, message });
    if (obj.message)
        message = obj.message;
    if (obj.error)
        error = obj.error;
    if (obj.events)
        events = obj.events;
    if (events)
        executeTag(events);
    if (obj.tracking)
        executeTag(obj.tracking);
    xhr.infoChecked = true;
    return {
        panel,
        auth,
        cart,
        error,
        message,
        events
    };
};
function extractInfo(page, { error = null, message = null } = {}) {
    let events = '';
    let tracking = '';
    let cartMessages = [];
    if (page) {
        if (!error || !message) {
            const errorMessage = page.querySelector('.error-message');
            const successMessage = page.querySelector('.success-message');
            cartMessages = Array.from(page.querySelectorAll('.cart-message'));
            if (errorMessage) {
                error = errorMessage.innerHTML;
                errorMessage.parentNode.removeChild(errorMessage);
            }
            else if (successMessage) {
                message = successMessage.innerHTML;
                successMessage.parentNode.removeChild(successMessage);
            }
        }
        const ga4Events = page.querySelector('script#ga4-events');
        if (ga4Events) {
            events = ga4Events.innerHTML;
            ga4Events.parentNode.removeChild(ga4Events);
        }
        const trackingScripts = page.querySelectorAll('script.tracking');
        if (trackingScripts.length) {
            for (let i = 0; i < trackingScripts.length; i++) {
                tracking += trackingScripts[i].innerHTML;
                trackingScripts[i].parentNode.removeChild(trackingScripts[i]);
            }
        }
        const listNameFields = Array.from(page.querySelectorAll('input[data-ref=listName][value=""]'));
        if (listNameFields.length) {
            for (let i = 0; i < listNameFields.length; i++)
                listNameFields[i].value = localStorage.getItem('list_name');
        }
    }
    if (error || message || cartMessages.length > 0) {
        if (cartMessages.length > 0) {
            for (let i = 0; i < cartMessages.length; i++) {
                store.message.set({
                    error: !!error,
                    cart: true,
                    text: error || message || cartMessages[i].innerHTML
                });
                page.querySelector('.cart-messages')?.remove();
            }
        }
        else {
            store.message.set({
                error: !!error,
                text: error || message,
                cart: false
            });
        }
    }
    return {
        error,
        message,
        events,
        tracking
    };
}
class CustomPageManager extends PageManager {
    async initializePage() {
        await super.initializePage();
        extractInfo(this.currentPage.el);
    }
    async pageLoaded(pathName, xhr, requestOptions) {
        const data = extractInfoFromXhr(xhr);
        const page = xhr?.response;
        if ((data.error || data.message) && !page?.body?.innerHTML) {
            this.cancelTransition();
            return false;
        }
        const currentRouter = await super.pageLoaded(pathName, xhr, requestOptions);
        if (currentRouter === true && this.state.next !== 'CheckoutSummary') {
            try {
                // @ts-ignore
                blueshift.pageload(); // eslint-disable-line no-undef
                const skus = xhr.getResponseHeader('X-Fursac-SKUs');
                // @ts-ignore
                if (skus)
                    blueshift.track('view', { products: JSON.parse(atob(skus)) }); // eslint-disable-line no-undef
            }
            catch (error) { }
        }
        return true;
    }
    extractPageFromXHR(root) {
        return super.extractPageFromXHR(root);
    }
    extractPageInfo(page) {
        return super.extractPageInfo(page);
    }
}
export default CustomPageManager;
